import { DEFAULT_SEARCH_SETTINGS } from 'constants/searchHelpers'

const publicConfig = ((global as any).__PUBLIC_CONFIG__ ?? (global as any).__STATIC_CONFIG__ ?? {})
const config: App.AppConfig = publicConfig as App.AppConfig

// Provide safe fallbacks for fields accessed at module-evaluation time in Storybook
;(config as any).agentHub = (config as any).agentHub ?? { isEnabled: false }
;(config as any).regions = (config as any).regions ?? []
;(config as any).search = (config as any).search ?? { ...DEFAULT_SEARCH_SETTINGS }
;(config as any).search.defaultOccupants = (config as any).search.defaultOccupants ?? DEFAULT_SEARCH_SETTINGS.defaultOccupants
;(config as any).loyalty = (config as any).loyalty ?? {
  programDisplayName: '',
  pointsUnit: '',
  pointsUnitAbbreviation: '',
  bonusPointsUnit: '',
  bonusPointsUnitAbbreviation: '',
  statusCreditsUnit: '',
  tiers: {},
  tiersOrder: [],
}
;(config as any).multiClickUnsubPage = (config as any).multiClickUnsubPage ?? { copyVariant: 'luxuryEscapes' }

export function setConfig(newConfig: Partial<App.AppConfig>) {
  Object.assign(config, newConfig)
  return config
}

export default config
